const state = {
  commentTree: [],
}

const getters = {
}

const mutations = {
  setCommentTree (state, list) {
    state.commentTree = list
  },
}

const actions = {
  searchCommentTree ({ state, commit, rootState }, params) {
    return rootState.axios.get('/taxonomy/v1frontend/term/search-comment-tree', { params })
      .then((res) => {
        commit('setCommentTree', res.data.list)
      })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
